export class TicketVariable {
}
export class TicketData {
}
//# sourceMappingURL=data.js.map